import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { CloseButton, Dropdown } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { PageHeader, Pagination } from '../../components';
import CheckableDataTable from '../../components/CheckableDataTable/CheckableDataTable';
import SearchByDate from '../../components/SearchByDate/SearchByDate.components';
import useComponentState from './../../utils/useComponentState';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Card } from 'react-bootstrap';
import { Checkbox, Drawer } from 'rsuite';
import connectPrinter from '../../utils/connectPrinter';
import { getGreetlyVouchers, getGreetlyVouchersByFilters, getTransactionDetails, handOverVoucher, setPrintDate, getGreetlyCsv } from '../../api/greetlyVouchers';
import { formatDateTime } from '../../utils/dataFormatter';
import { formatAmount } from '../../utils/amountFormatter';
import { DATE_TIME_TYPES } from '../../constants/dataTimeTypes';
import styles from './GreetlyVouchers.module.scss';
import PropTypes from 'prop-types';
import {
    INITIAL_STATE,
} from './greetlyVouchersConstants';
import {
    buildLabelObject,
    buildCheckedRowObject,
    getSearchNotFoundMessage,
    getStatusFilterNotFoundMessage,
    generateZPLCodes,
    findCheckedRowIndex,
    findVoucherByGreetlyId,
    deduplicateItems,
    filterOutByIds,
} from './greetlyVouchersUtils';


const GreetlyVouchers = (props) => {
    const [state, setState] = useComponentState(INITIAL_STATE);

    const {
        tableHeading,
        voucherData,
        loading,
        totalPages,
        currentPage,
        fetchError,
        selectAll,
        checkedRows,
        labelsToPrint,
        csvLoading,
        searchDropDown,
        subSearchDropDown,
        searchPlaceholder,
        subSearchPlaceholder,
        searchId,
        subSearchId,
        isVoucherTopup,
        isVoucherCreated,
        isHandedOver,
        isClearable,
        isClearableSub,
        startDate,
        endDate,
        notFoundMessage,
        showVoucherDrawer,
        drawerData,
        showTransactions,
        transactionDetails,
        transactionLoading,
        transactionError,
        selectedTransaction,
    } = state;

    useEffect(() => {
        //getVoucherDetails(state.currentPage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getVoucherDetails = async (page) => {
        setState(prev => ({ ...prev, loading: true, fetchError: '' }));
        try {
            const params = {
                page: page !== undefined ? page : state.currentPage,
                pageSize: state.pageSize,
                sortBy: state.sortBy,
                order: state.order,
                isVoucherAvailable: true,
                filterType: state.statusKey !== 'ALL' ? state.statusKey : null,
            };

            const response = await getGreetlyVouchers(props.auth.auth.token, params);
            if (response.list && response.list.length >= 0) {
                const notFoundMessage = response.list.length === 0
                    ? getStatusFilterNotFoundMessage(state.tabItems.status, state.statusKey)
                    : null;

                setState(prev => ({
                    ...prev,
                    voucherData: response.list,
                    totalPages: response.totalPageCount || 0,
                    currentPage: response.pageNo || 0,
                    loading: false,
                    notFoundMessage,
                }));
            } else {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    fetchError: response.message || 'Failed to fetch vouchers',
                    notFoundMessage: 'No vouchers found',
                }));
            }
        } catch (error) {
            console.error('Error fetching vouchers:', error);
            setState(prev => ({
                ...prev,
                loading: false,
                fetchError: 'Error fetching voucher details',
                notFoundMessage: 'Error fetching voucher details',
            }));
        }
    };

    const filterByIdsApi = async (page, start, end) => {
        setState(prev => ({
            ...prev,
            loading: true,
            isFilterApiCalled: true,
        }));
        try {
            // Map searchKey to searchId for API
            const searchIdMap = {
                'GREETLY_ID': 'greetlyId',
                'VOUCHER_ID': 'voucherId',
                'THEME_NAME': 'themeName',
                'BATCH_ID': 'batchId',
                'STORE': 'store',
            };

            const subSearchIdMap = {
                'LOCATION': 'location',
            };

            const params = {
                page,
                searchId: start ? null : searchIdMap[state.searchKey] || state.searchKey,
                searchKey: state.searchId,
                subSearchId: start ? null : subSearchIdMap[state.subSearchKey] || state.subSearchKey,
                subSearchKey: state.subSearchId,
                startDate: start ? start : null,
                endDate: end ? end : null,
                isVoucherCreated: isVoucherCreated,
                isVoucherTopup: isVoucherTopup,
                isHandedOver: isHandedOver,
            };

            const response = await getGreetlyVouchersByFilters(props.auth.auth.token, params);
            if (response.list) {
                const notFoundMessage = response.list.length === 0
                    ? getSearchNotFoundMessage(state.searchKey, state.searchId, state.subSearchKey, state.subSearchId)
                    : null;

                setState(prev => ({
                    ...prev,
                    voucherData: response.list,
                    totalPages: response.totalPageCount || 0,
                    currentPage: response.pageNo || 0,
                    loading: false,
                    notFoundMessage,
                }));
            } else {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    voucherData: [],
                    totalPages: 0,
                    currentPage: 0,
                    notFoundMessage: getSearchNotFoundMessage(state.searchKey, state.searchId),
                }));
            }
        } catch (err) {
            setState(prev => ({
                ...prev,
                loading: false,
                voucherData: [],
                totalPages: 0,
                currentPage: 0,
                notFoundMessage: getSearchNotFoundMessage(state.searchKey, state.searchId),
            }));
        }
    };

    const handlePrintCodes = async () => {
        const zpl = generateZPLCodes(checkedRows);

        try {
            const device = await connectPrinter();
            const encoder = new TextEncoder();
            const data = encoder.encode(zpl);

            await device.transferOut(1, data);

            const payload = {
                greetlyIds: checkedRows.map(row => row.greetlyId),
            };
            await setPrintDate(props.auth.auth.token, payload);
        } catch (error) {
            toast.error('Failed to print QR codes. Please check printer connection.');
        }
    };

    const handleDownloadCsv = async () => {
        setState(prev => ({ ...prev, csvLoading: true }));
        try {
            const searchIdMap = {
                'GREETLY_ID': 'greetlyId',
                'VOUCHER_ID': 'voucherId',
                'THEME_NAME': 'themeName',
                'BATCH_ID': 'batchId',
                'STORE': 'store',
            };
            const subSearchIdMap = {
                'LOCATION': 'location',
            };
            const payload = {
                page: state.currentPage,
                searchId: searchIdMap[state.searchKey] || state.searchKey,
                searchKey: state.searchId,
                subSearchId: subSearchIdMap[state.subSearchKey] || state.subSearchKey,
                subSearchKey: state.subSearchId,
                startDate: state.startDate || null,
                endDate: state.endDate || null,
                isVoucherCreated: state.isVoucherCreated,
                isVoucherTopup: state.isVoucherTopup,
                isHandedOver: state.isHandedOver,
            };
            const blob = await getGreetlyCsv(props.auth.auth.token, payload);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'greetly-vouchers.csv';
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            toast.error('Failed to download CSV. Please try again.');
        } finally {
            setState(prev => ({ ...prev, csvLoading: false }));
        }
    };

    const handleHandOverVouchers = async () => {
        if (checkedRows.length === 0) {
            toast.error('No vouchers selected for hand over');
            return;
        }

        try {
            const payload = {
                greetlyIds: checkedRows.map(row => row.greetlyId),
            };

            setState(prev => ({ ...prev, loading: true }));
            const response = await handOverVoucher(props.auth.auth.token, payload);

            if (response && response.success) {
                toast.success('Vouchers handed over successfully');
                // Reset selection after successful hand over
                setState(prev => ({
                    ...prev,
                    checkedRows: [],
                    labelsToPrint: [],
                    selectAll: false,
                    loading: false,
                }));
                // Optionally refresh the data
                getVoucherDetails(state.currentPage);
            } else {
                const errorMessage = response?.message || 'Failed to hand over vouchers';
                toast.error(errorMessage);
                setState(prev => ({ ...prev, loading: false }));
            }
        } catch (error) {
            toast.error('Error during over vouchers');
            setState(prev => ({ ...prev, loading: false }));
        }
    };

    const handlePagination = (page) => {
        if (state.isFilterApiCalled) {
            filterByIdsApi(page, state.startDate, state.endDate);
        } else {
            getVoucherDetails(page);
        }
    };

    const handleIdSearch = () => {
        const { searchId, subSearchId } = state;
        if (searchId || subSearchId) {
            setState({
                isSearchApiCalled: true,
                isFilterApiCalled: false,
                isClearable: !!searchId,
                isClearableSub: !!subSearchId,
            });
            filterByIdsApi(0, state.startDate, state.endDate);
        }
    };

    const handleMainClear = () => {
        setState({
            searchId: '',
            isSearchApiCalled: false,
            isClearable: false,
            notFoundMessage: null,
        });
    }

    const handleSubClear = () => {
        setState({
            subSearchId: '',
            isSearchApiCalled: false,
            isClearableSub: false,
            notFoundMessage: null,
        });
    };

    const searchOnChange = (event) => {
        setState({
            searchId: event.target.value,
            isClearable: false,
        });
    };

    const subSearchOnChange = (event) => {
        setState({
            subSearchId: event.target.value,
            isClearableSub: false,
        });
    };

    const onChangeStartDate = (startDateVal) => {
        const { endDate: endDateVal } = state;
        setState({ startDate: startDateVal });
        if (startDateVal && endDateVal) {
            setState({ isFilterApiCalled: true });
            filterByIdsApi(0, startDateVal, endDateVal);
        }
        if (!startDateVal && !endDateVal) {
            setState({ isFilterApiCalled: false });
            getVoucherDetails(0);
        }
    };

    const onChangeEndDate = (endDateVal) => {
        const { startDate: startDateVal } = state;
        setState({ endDate: endDateVal });
        if (startDateVal && endDateVal) {
            setState({ isFilterApiCalled: true });
            filterByIdsApi(0, startDateVal, endDateVal);
        }
        if (!startDateVal && !endDateVal) {
            setState({ isFilterApiCalled: false });
            getVoucherDetails(0);
        }
    };

    const handleSearchDropDownOnClick = (key, label) => {
        setState({
            searchPlaceholder: label,
            searchKey: key,
            searchId: '',
            isClearable: false,
        });
    };

    const handleSubSearchDropDownOnClick = (key, label) => {
        setState({
            subSearchPlaceholder: label,
            subSearchKey: key,
            subSearchId: '',
            isClearableSub: false,
        });
    }

    const renderMultipleSearch = () => {
        return (
            <InputGroup className='mb-3'>
                <DropdownButton
                    as={InputGroup.Prepend}
                    variant='secondary'
                    title={searchPlaceholder}
                    id='input-group-dropdown-1'
                >
                    {searchDropDown.map((item) => {
                        const { key, label } = item;
                        return (
                            <Dropdown.Item
                                key={key}
                                onClick={() => handleSearchDropDownOnClick(key, label)}
                            >
                                {label}
                            </Dropdown.Item>
                        );
                    })}
                </DropdownButton>
                <Form.Control
                    placeholder={searchPlaceholder}
                    value={searchId}
                    onChange={searchOnChange}
                    required
                    maxLength={50}
                />
                <InputGroup.Append>
                    {isClearable && <Button variant='secondary' onClick={handleMainClear}>
                        <FontAwesomeIcon
                            icon={faTimes}
                        />
                    </Button>}
                </InputGroup.Append>
            </InputGroup>
        );
    };

    const renderSubSearch = () => {
        return (
            <InputGroup className='mb-3'>
                <DropdownButton
                    as={InputGroup.Prepend}
                    variant='secondary'
                    title={subSearchPlaceholder}
                    id='input-group-dropdown-1'
                >
                    {subSearchDropDown.map((item) => {
                        const { key, label } = item;
                        return (
                            <Dropdown.Item
                                key={key}
                                onClick={() => handleSubSearchDropDownOnClick(key, label)}
                            >
                                {label}
                            </Dropdown.Item>
                        );
                    })}
                </DropdownButton>
                <Form.Control
                    placeholder={subSearchPlaceholder}
                    value={subSearchId}
                    onChange={subSearchOnChange}
                    required
                    maxLength={10}
                />
                <InputGroup.Append>
                    {isClearableSub && <Button variant='secondary' onClick={handleSubClear}>
                        <FontAwesomeIcon
                            icon={faTimes}
                        />
                    </Button>}
                </InputGroup.Append>
            </InputGroup>
        );
    };


    const handleCheckBoxToggle = (rowId, event) => {
        event.stopPropagation();
        handleCheck(rowId);
    };

    const handleCheck = (rowId) => {
        // rowId is greetlyId
        setState((prev) => {
            const existingIndex = findCheckedRowIndex(prev.checkedRows, rowId);
            let newChecked = [...prev.checkedRows];
            let labels = [...prev.labelsToPrint];

            if (existingIndex > -1) {
                // remove
                const removed = newChecked.splice(existingIndex, 1)[0];
                labels = labels.filter((lbl) => lbl.id !== removed.voucherId);
            } else {
                // add
                const data = findVoucherByGreetlyId(voucherData, rowId);
                if (data) {
                    newChecked.push(buildCheckedRowObject(data));
                    // labels.push(buildLabelObject(data));
                }
            }

            // Determine if all rows are now selected
            const allSelected = voucherData.length > 0 && voucherData.every((v) =>
                newChecked.some((c) => c.greetlyId === v.greetlyId)
            );

            return {
                ...prev,
                selectAll: allSelected,
                checkedRows: newChecked,
                labelsToPrint: labels,
            };
        });
    };

    const handleMultipleCheck = (ids) => {
        // ids are greetlyIds
        setState((prev) => {
            let newChecked = [...prev.checkedRows];
            let labels = [...prev.labelsToPrint];

            ids.forEach((id) => {
                const existingIndex = findCheckedRowIndex(newChecked, id);
                if (existingIndex > -1) {
                    const removed = newChecked.splice(existingIndex, 1)[0];
                    labels = labels.filter((lbl) => lbl.id !== removed.voucherId);
                } else {
                    const data = findVoucherByGreetlyId(voucherData, id);
                    if (data) {
                        newChecked.push(buildCheckedRowObject(data));
                        labels.push(buildLabelObject(data));
                    }
                }
            });

            // Determine if all rows are now selected
            const allSelected = voucherData.length > 0 && voucherData.every((v) =>
                newChecked.some((c) => c.greetlyId === v.greetlyId)
            );

            return {
                ...prev,
                selectAll: allSelected,
                checkedRows: newChecked,
                labelsToPrint: labels,
            };
        });
    };

    const handleSelectAll = (event) => {
        const checked = event.target.checked;
        if (checked) {
            const selectedAll = voucherData.map(buildCheckedRowObject);
            const newLabels = voucherData.map(buildLabelObject);
            setState((prev) => ({
                selectAll: true,
                checkedRows: deduplicateItems(
                    [...prev.checkedRows, ...selectedAll],
                    'greetlyId'
                ),
                labelsToPrint: deduplicateItems(
                    [...prev.labelsToPrint, ...newLabels],
                    'id'
                ),
            }));
        } else {
            const voucherGreetlyIds = new Set(voucherData.map((d) => d.greetlyId));
            const voucherIds = new Set(voucherData.map((d) => d.voucher.id));
            setState({
                checkedRows: filterOutByIds(checkedRows, voucherGreetlyIds, 'greetlyId'),
                labelsToPrint: filterOutByIds(labelsToPrint, voucherIds, 'id'),
            });
        }
    };

    const handleOnClick = (greetlyId) => {
        // Toggle checkbox
        setState(prev => {
            const existingIndex = findCheckedRowIndex(prev.checkedRows, greetlyId);
            let newChecked = [...prev.checkedRows];

            if (existingIndex > -1) {
                newChecked.splice(existingIndex, 1);
            } else {
                const data = findVoucherByGreetlyId(voucherData, greetlyId);
                if (data) newChecked.push(buildCheckedRowObject(data));
            }

            const allSelected = voucherData.length > 0 && voucherData.every(v =>
                newChecked.some(c => c.greetlyId === v.greetlyId)
            );

            return {
                ...prev,
                checkedRows: newChecked,
                selectAll: allSelected,
            };
        });

        // Open drawer as before
        const selectedVoucher = voucherData.find(v => v.greetlyId === greetlyId);
        if (selectedVoucher) {
            setState(prev => ({
                ...prev,
                showVoucherDrawer: true,
                drawerData: selectedVoucher,
                voucherId: selectedVoucher.voucher.id,
            }));
        }
    };


    // Handler to close drawer and reset state
    const handleDrawerOnHide = () => {
        setState({
            showVoucherDrawer: false,
            drawerData: null,
            voucherId: null,
            showTransactions: false,
            transactionDetails: [],
            selectedTransaction: null,
            transactionError: '',
        });
    };

    // Get transaction details for the selected voucher
    const getTransactionDetailsForVoucher = async (greetlyId) => {
        setState(prev => ({ ...prev, transactionLoading: true, transactionError: '' }));
        try {
            const response = await getTransactionDetails(props.auth.auth.token, greetlyId);
            if (response && response.greetlyTransactionList && Array.isArray(response.greetlyTransactionList)) {
                setState(prev => ({
                    ...prev,
                    transactionDetails: response.greetlyTransactionList,
                    transactionLoading: false,
                }));
            } else {
                setState(prev => ({
                    ...prev,
                    transactionDetails: [],
                    transactionLoading: false,
                    transactionError: 'Failed to fetch transaction details',
                }));
            }
        } catch (error) {
            toast.error('Failed to fetch transaction details');
            setState(prev => ({
                ...prev,
                transactionLoading: false,
                transactionError: 'Error fetching transaction details',
            }));
        }
    };

    // Handler for viewing transactions in drawer - fetches transactions when button is clicked
    const handleShowTransactions = () => {
        if (!showTransactions) {
            // Show transactions and fetch data
            setState(prev => ({
                ...prev,
                transactionLoading: true,
            }));
            getTransactionDetailsForVoucher(drawerData.greetlyId);
            setState(prev => ({
                ...prev,
                showTransactions: true,
                selectedTransaction: null,
            }));
        } else {
            // Hide transactions and go back to voucher details
            setState(prev => ({
                ...prev,
                showTransactions: false,
                selectedTransaction: null,
            }));
        }
    };

    // Handler for clicking on a transaction row
    const handleTransactionRowClick = (transaction) => {
        setState({ selectedTransaction: transaction });
    };

    // Handler to go back from transaction details
    const handleTransactionGoBack = () => {
        setState({
            showTransactions: false,
            selectedTransaction: null,
        });
    };

    const handleFilterCheckboxChange = (key) => {

        switch (key) {
            case 'isVoucherTopup':
                setState((prev) => ({
                    ...prev,
                    isVoucherTopup: !prev.isVoucherTopup,
                }));
                break;

            case 'isVoucherCreated':
                setState((prev) => ({
                    ...prev,
                    isVoucherCreated: !prev.isVoucherCreated,
                }));
                break;
            case 'isHandedOver':
                setState((prev) => ({
                    ...prev,
                    isHandedOver: !prev.isHandedOver,
                }));
                break;

            default:
                break;
        }
    }


    useEffect(() => {
        setState({ currentPage: 0 });
        filterByIdsApi(0, state.startDate, state.endDate);
    }, [state.isVoucherTopup, state.isVoucherCreated, state.isClearable, state.isClearableSub, state.isHandedOver]);

    // Render transaction details in drawer
    const renderTransactionDetails = (data) => {
        if (!data) return null;
        return (
            <div className={`details_group ${styles.content}`}>
                <Card>
                    <Card.Body>
                        <div className='detail_group_content'>
                            <span className='content_header'>Description</span>
                            <span className='content_value'>{data.description || 'N/A'}</span>
                        </div>
                        <div className='detail_group_content'>
                            <span className='content_header'>Amount</span>
                            <span className='content_value'>{formatAmount(data.amount) || 'N/A'}</span>
                        </div>
                        <div className='detail_group_content'>
                            <span className='content_header'>Date</span>
                            <span className='content_value'>{formatDateTime(data.transactionDate, DATE_TIME_TYPES.ISO_DATE_TIME) || 'N/A'}</span>
                        </div>
                    </Card.Body>
                </Card>
            </div>
        );
    };

    // Render Greetly voucher details in drawer
    const renderVoucherDetailsInDrawer = (data) => {
        if (!data) return null;
        const voucher = data.voucher;

        const primaryContent = [
            {
                label: 'Greetly ID',
                value: data.greetlyId,
            },
            {
                label: 'Voucher ID',
                value: voucher.id,
            },
            {
                label: 'Theme',
                value: voucher.coreVoucherTheme?.name || 'N/A',
            },
            {
                label: 'Amount',
                value: formatAmount(voucher.amount),
            },
            {
                label: 'Status',
                value: voucher.status || 'N/A',
            },
            {
                label: 'Created Date',
                value: formatDateTime(voucher.createdDate, DATE_TIME_TYPES.ISO_DATE_TIME),
            },
            {
                label: 'Expiry Date',
                value: voucher.expiryDate ? formatDateTime(voucher.expiryDate, DATE_TIME_TYPES.ISO_DATE_TIME) : 'N/A',
            },
            {
                label: 'Batch ID',
                value: data.batchId || 'N/A',
            },
            {
                label: 'Store',
                value: data.store || 'N/A',
            },
            {
                label: 'Handed Over At',
                value: data.handedOverAt ? formatDateTime(data.handedOverAt, DATE_TIME_TYPES.ISO_DATE_TIME) : 'N/A',
            }
        ];

        return (
            <div className={`details_group ${styles.content}`}>
                <Card>
                    <Card.Body>
                        {primaryContent.map((item, index) => (
                            <div key={index} className='detail_group_content'>
                                <span className='content_header'>{item.label}</span>
                                <span className='content_value'>{item.value}</span>
                            </div>
                        ))}
                    </Card.Body>
                </Card>
            </div>
        );
    };

    // Render the drawer component
    const renderDrawer = () => {
        if (!drawerData) return null;

        return (
            <div className='purchase_drawer_root'>
                <div className='drawer_child'>
                    <div className='header_group'>
                        <span className='header_title'>Greetly Voucher ID</span>
                        <span className='header_value'>{drawerData.greetlyId}</span>
                    </div>

                    {selectedTransaction ? (
                        renderTransactionDetails(selectedTransaction)
                    ) : (
                        <>
                            {showTransactions ? (
                                <div className={`details_group ${styles.content}`}>
                                    {transactionLoading ? (
                                        <div className={styles.loadingContainer}>
                                            <FontAwesomeIcon icon={faSpinner} spin /> Loading transactions...
                                        </div>
                                    ) : transactionDetails.length > 0 ? (
                                        <div className={styles.transactionsWrapper}>
                                            <table className={styles.transactionsTable}>
                                                <thead className={styles.transactionsTableHeader}>
                                                    <tr className={styles.transactionTableRow}>
                                                        <th className={styles.transactionHeader}>Description</th>
                                                        <th className={styles.transactionHeader}>Date</th>
                                                        <th className={styles.transactionHeader}>Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {transactionDetails.map((transaction, index) => (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                borderBottom: '1px solid #ddd',
                                                                cursor: 'pointer',
                                                                backgroundColor: selectedTransaction === transaction ? '#f0f0f0' : 'white',
                                                            }}
                                                            onClick={() => handleTransactionRowClick(transaction)}
                                                        >
                                                            <td style={{ padding: '10px' }}>{transaction.description || 'N/A'}</td>
                                                            <td style={{ padding: '10px' }}>{formatDateTime(transaction.transactionDate, DATE_TIME_TYPES.ISO_DATE_TIME)}</td>
                                                            <td style={{ padding: '10px', textAlign: 'right' }}>{formatAmount(transaction.amount)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className={styles.noTransactionsMessage}>
                                            {transactionError || 'No transactions found'}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                renderVoucherDetailsInDrawer(drawerData)
                            )}
                        </>
                    )}

                    <div className={`footer ${styles.footerContent}`}>
                        <div className={`button-container ${styles.buttonGroup}`}>
                            {selectedTransaction ? (
                                <Button
                                    className={styles.buttonFlex}
                                    onClick={() => handleTransactionGoBack()}
                                >
                                    Go Back
                                </Button>
                            ) : (
                                <Button
                                    className={styles.buttonFlex}
                                    onClick={handleShowTransactions}
                                    disabled={transactionLoading}
                                >
                                    {showTransactions ? 'View Greetly Details' : 'View Transactions'}
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className={styles.root_div}>
            <div>
                <PageHeader text='Greetly Vouchers' />

                <div className={styles.search_area_block}>
                    <div className={styles.search_area}>{renderMultipleSearch()}</div>
                    <div>{renderSubSearch()}</div>
                    <div style={{ display: 'flex' }}>
                        <Checkbox checked={state.isVoucherTopup} onChange={() => handleFilterCheckboxChange('isVoucherTopup')}>Toped Up</Checkbox>
                        <Checkbox checked={state.isVoucherCreated} onChange={() => handleFilterCheckboxChange('isVoucherCreated')}>Voucher Created</Checkbox>
                        <Checkbox checked={state.isHandedOver} onChange={() => handleFilterCheckboxChange('isHandedOver')}>Handed Over</Checkbox>
                    </div>
                    <SearchByDate
                        onStartDateChange={onChangeStartDate}
                        onEndDateChange={onChangeEndDate}
                        startDate={startDate}
                        endDate={endDate}
                    />
                    <Button variant='secondary' onClick={handleIdSearch} className={styles.search_button}>
                        <FontAwesomeIcon
                            icon={faSearch}
                        />
                        Search
                    </Button>
                    <div className={styles.seperator} />
                </div>

                <div className={styles.print_button_block}>
                    <InputGroup className={`${styles.input_group} mb-3`}>
                        <Dropdown>
                            <Dropdown.Toggle
                                disabled={checkedRows.length === 0}
                                variant='primary'
                                id='dropdown-basic'
                            >
                                Print QR Codes
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => handlePrintCodes()}>
                                    Print with Zebra
                                </Dropdown.Item>

                            </Dropdown.Menu>
                        </Dropdown>

                        <Dropdown>
                            <Dropdown.Toggle
                                disabled={checkedRows.length === 0 || loading}
                                variant="primary"
                                id="handover-btn"
                                className={styles.noCaret}
                                onClick={handleHandOverVouchers}   // behave like normal button
                            >
                                Hand Over
                            </Dropdown.Toggle>

                            {/* Empty menu (not displayed) */}
                            <Dropdown.Menu className={styles.hiddenMenu}></Dropdown.Menu>
                        </Dropdown>

                        <Button
                            variant="secondary"
                            onClick={handleDownloadCsv}
                            disabled={csvLoading}
                        >
                            {csvLoading ? (
                                <><FontAwesomeIcon icon={faSpinner} spin /> Downloading...</>
                            ) : (
                                'Download CSV'
                            )}
                        </Button>
                    </InputGroup>

                </div>

                <div className='mb-3 d-flex align-items-end'>
                    {checkedRows.length > 0 && (
                        <>
                            <span className={styles.selectedCountText}>
                                {checkedRows.length} voucher
                                {checkedRows.length > 1 ? 's' : ''} selected
                            </span>
                            <span>
                                <CloseButton
                                    className='ml-2'
                                    onClick={() => {
                                        setState({ checkedRows: [], labelsToPrint: [] });
                                    }}
                                />
                            </span>
                        </>
                    )}
                </div>

                <div>
                    <CheckableDataTable
                        tableData={voucherData}
                        tableheading={tableHeading}
                        tag='greetly-vouchers'
                        fetchError={notFoundMessage || fetchError}
                        notFoundMessage={notFoundMessage || fetchError}
                        search_filter_loading={loading}
                        handleCheck={handleCheckBoxToggle}
                        handleSelectAll={handleSelectAll}
                        handleMultipleCheck={() => { }}
                        handleOnClick={handleOnClick}
                        searchFilterLoading={loading}
                        checkedRows={checkedRows.map((c) => c.greetlyId)}
                        selectAll={selectAll}
                    />
                    {!loading && !notFoundMessage && !fetchError && (
                        <Pagination
                            pageCount={totalPages}
                            onChange={handlePagination}
                            currentPage={currentPage}
                        />
                    )}
                </div>

                {/* Drawer for Greetly Voucher Details */}
                <Drawer show={showVoucherDrawer} onHide={handleDrawerOnHide}>
                    <Drawer.Header closeButton>
                        <Drawer.Title>Greetly Voucher Details</Drawer.Title>
                    </Drawer.Header>
                    <Drawer.Body>
                        {renderDrawer()}
                    </Drawer.Body>
                </Drawer>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    };
};

GreetlyVouchers.propTypes = {
    auth: PropTypes.shape({
        auth: PropTypes.shape({
            token: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};

export default connect(mapStateToProps)(GreetlyVouchers);
